import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  IsCompleteYourLookOfferingEnabledView,
  ViewIsCompleteYourLookOfferingEnabledResult,
} from "../../../projection/offering/viewIsCompleteYourLookOfferingEnabled";

interface ViewIsCompleteYourLookOfferingEnabledResponse {
  readonly active: boolean;
}

interface HttpCompleteYourLookOfferingEnabledView extends IsCompleteYourLookOfferingEnabledView {}

interface HttpCompleteYourLookOfferingEnabledViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpCompleteYourLookOfferingEnabledViewFunction {
  (args: HttpCompleteYourLookOfferingEnabledViewFunctionArgs): HttpCompleteYourLookOfferingEnabledView;
}

const httpCompleteYourLookOfferingEnabledView: HttpCompleteYourLookOfferingEnabledViewFunction =
  ({ httpPost }) =>
  async ({ signal }) =>
    await httpPost<ViewIsCompleteYourLookOfferingEnabledResponse, ViewIsCompleteYourLookOfferingEnabledResult>({
      endpoint: "/looks/v2/has-access",
      body: {},
      signal,
      result: {
        error: false,
        success: (response) => response?.active ?? false,
      },
    });

export { httpCompleteYourLookOfferingEnabledView };
